import * as React from "react";

interface LogoutButtonProps {
  onClick: () => void;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ onClick }) => {
  return (
    <button className="logout-btn" onClick={onClick} aria-label="Log out">
      Log out
    </button>
  );
};

export default LogoutButton;
